<template>
  <div class="container">
    <div class="company inner">
      <div class="posite">
        <ul class="posite-menu"></ul>
         <div class="posite-map posite-map1">
          <span><i class="iconfont">&#xe65e;</i>当前位置：</span>
          <router-link to="/">首页</router-link>
          <b>></b>
           <router-link to="/jzabout">成果转化</router-link>
          <b>></b>
          <span>{{activeNmaes}}</span>
        </div>
      </div>
      <div class="company-fixe">
        <div class="company-btn">
          <div class="company-btnItem" :class="{'active': activeIndex == index}" v-for="(item, index) in taskData" @click="companyTab(index)" :key="item.catid">
            <a href="javascript:;">{{item.name}}</a>
          </div>
        </div>
        <div class="company-tabs">
          <div class="company-tabs-item" v-show="activeIndex == 0">
            <div class="compnay-title">
              <strong>{{taskData[0].name}}</strong>
            </div>
            <div class="guide">
              <div class="guide-item">
                <div class="goal goal1" v-html="taskData[0].content">
                </div>
              </div>
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 1">
            <div class="compnay-title">
              <strong>{{taskData[1].name}}</strong>
            </div>
            <div class="foundate" v-html="taskData[1].content">
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 2">
            <div class="compnay-title">
              <strong>{{taskData[2].name}}</strong>
            </div>
            <div class="goal" v-html="taskData[2].content">
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 3">
            <div class="compnay-title">
              <strong>{{taskData[3].name}}</strong>
            </div>
            <div class="goal" v-html="taskData[3].content">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        name: 'keyWords',
        content: this.keyWords
      },
      {
        name: 'description',
        content: this.description
      }]
    }
  },
  data () {
    return {
      compatyData: {},
      activeIndex: 0,
      targeData: {},
      activeNmaes: '知识产权运营中心',
      taskData: [],
      title: '',
      keyWords: '',
      description: ''
    }
  },
  methods: {
    companyTab (index) {
      this.activeIndex = index
      this.activeNmaes = this.taskData[this.activeIndex].name
    },
    async getData () {
      const { data: res3 } = await this.$http.get('/fdata/category?catid=103')
      const { data: res1 } = await this.$http.get('/fdata/page_show?catid=121')
      const { data: res2 } = await this.$http.get('/fdata/page_show?catid=122')
      const { data: res4 } = await this.$http.get('/fdata/page_show?catid=123')
      const { data: res5 } = await this.$http.get('/fdata/page_show?catid=124')
      if (res3.code === 1) {
        console.log(res2)
        this.taskData.push(res1.data)
        this.taskData.push(res2.data)
        this.taskData.push(res4.data)
        this.taskData.push(res5.data)
        console.log(this.taskData)
        this.title = res3.data[0].seotitle
        this.keyWords = res3.data[0].seokeywords
        this.description = res3.data[0].seodescription
      }
    }
  },
  mounted () {
    if (Number(this.$route.query.layIndex) > 0) {
      console.log(this.$route.query.layIndex)
      this.activeIndex = this.$route.query.layIndex
    }
    this.getData()
  },
  components: {
  },
  watch: {
    $route (to, from) {
      this.activeIndex = this.$route.query.layIndex
      this.activeNmaes = this.taskData[this.activeIndex].name
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
@import url("@/assets/css/common/index.less");
</style>
